import { useQuery } from "react-query";
import { ActivityService } from "$services";
import useAuth from "./useAuth";
import { Activity } from "$types";

export const useActivitiesQuery = () => {
  const { token } = useAuth();

  return useQuery<Activity[]>(
    ["getActivities"], // Using string key as it might not be in enum yet, or I'll add it
    () => ActivityService.getActivities(token),
    {
      enabled: !!token,
      staleTime: 60 * 60 * 1000, // Activities change rarely
    }
  );
};
